<template>
    <header class="heading-section">
        <div v-if="!$auth.status" class="container-fluid">
            <div class="haeder-nav flex-d">
                <div class="header-logo" v-if="$siteSettings?.data">
                    <router-link to="/">
                        <img  rel="preload"  :src="$siteSettings?.data?.aws_url + $siteSettings?.data?.storage_path?.domain_image + $siteSettings?.data?.logo" alt="">
                    </router-link>
                </div>
                <div class="user-login index-view">
                    <div class="mobile-login flex-d">
                        <button v-if="$siteSettings?.data?.business_type == 2" type="button" class="btn btn-login-1 btn-register" data-bs-toggle="modal"
                            data-bs-target="#register-btn">
                            {{ $t('register','Register')}}
                        </button>
                        <button v-else class="btn btn-login-1 btn-register" @click="demoLoginServiceCall">
                            {{ $t('demo', 'Demo') }}
                        </button>
                        <button type="button" class="btn btn-login-1" data-bs-toggle="modal" data-bs-target="#staticBackdrop-one">
                            <i class="fa-solid fa-user"></i>{{ $t('login','Login')}}
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div v-else-if="$auth.status" class="container-fluid">
            <div class="haeder-nav flex-d">
                <div class="top-side-search">
                    <div class="header-logo">
                        <router-link to="/">
                            <img  rel="preload"  :src="$siteSettings?.data?.aws_url + $siteSettings?.data?.storage_path?.domain_image + $siteSettings?.data?.logo" alt="">
                        </router-link>
                    </div>
                </div>
                <div class="user-login">
                    <div class="main-exposure ng-star-inserted">
                        <div class="be_div">
                            <p v-if="$siteSettings?.data?.business_type == 1">
                                <router-link to="/market-analysis">
                                    
                                    {{ $t('bal', 'Bal') }}:<b v-if="$auth?.user">{{ $helper.formatNumber($auth?.user?.balance) }}</b>
                                </router-link>
                                <router-link to="/market-analysis">
                                    
                                    {{ $t('exp', 'Exp') }}:<b v-if="$auth?.user">{{ $helper.formatNumber($auth?.user?.expl ?? 0) }}</b>
                                </router-link>
                            </p>
                            <p v-else>
                                <router-link to="/market-analysis">
                                    {{ $t('bal', 'Bal') }}:<b v-if="$auth?.user">{{ $helper.formatNumber($auth?.user?.balance) }}</b>
                                </router-link>
                                
                                <router-link to="/market-analysis">
                                    {{ $t('exp', 'Exp') }}:<b v-if="$auth?.user">{{ $helper.formatNumber($auth?.user?.expl ?? 0)  }}</b>
                                </router-link>
                            </p>
                        </div>
                        <div class="dropdown drop-side">
                            <button class="btn btn-secondary dropdown-toggle drop-menu" type="button" data-bs-toggle="offcanvas"
                                data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                                <i class="fa-solid fa-user"></i>{{ $t('my-account','My Account')}}
                            </button>
                        </div>
                    </div>
                </div>
                
                <div class="balance">
                    <div class="mo_user-blnc">
                        <b v-if="$auth?.user" class="head-username"><i class="fa-solid fa-user"></i>{{ $auth?.user?.userid }}</b>
                        <ul v-if="$siteSettings?.data?.business_type == 1">
                            <li>
                                <router-link to="/market-analysis">
                                    {{ $t('bal', 'Bal') }}:<b v-if="$auth?.user"> ({{ $helper.formatNumber($auth?.user?.balance) }})</b>
                                </router-link>
                            </li>
                            <li>
                                <router-link :to="{ name: 'multi-market' }"  class="exp-topcount">{{ $t('exp', 'Exp') }}
                                    
                                    <span v-if="$auth?.user" class="exp">({{ $auth.user?.expl ? (-1) * $auth.user.expl : 0.00 }})</span>
                                </router-link>
                            </li>
                        </ul>
                        <ul v-else>
                            <li>
                                <router-link to="/market-analysis">
                                    {{ $t('bal', 'Bal') }}:<b v-if="$auth?.user"> ({{ $helper.formatNumber($auth?.user?.balance) }})</b>    
                                </router-link>
                            </li>
                            <li>
                                <router-link to="/market-analysis" class="exp-topcount">{{ $t('exp', 'Exp') }}:
                                    
                                    <span v-if="$auth?.user" class="exp">({{ $auth.user?.expl ? (-1) * $auth.user.expl : 0.00 }})</span>
                                </router-link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="header-deposit-withdraw-btn-sec" v-if="$siteSettings?.data?.business_type == '2'">
                <a @click="goToWalletDeposit()" class="btn_deposit"> 
                    <img  rel="preload"  src="@/assets/images/deposit-icon.png" class="img-fluid">{{ $t('deposit', 'Deposit') }}
                </a>
                <a @click="goToWalletWithdraw()" class="btn_withdrawal">
                    <img  rel="preload"  src="@/assets/images/withdrawal-icon.png" class="img-fluid">{{ $t('withdrawal', 'Withdrawal') }}
                </a>
            </div>
        </div>
    </header>
    <Login/>
	<SignUp/>
    <ForgetPassword/>
    <Account v-if="$auth.status"/>
</template>
<script>
import { defineAsyncComponent } from 'vue';
import { AUTH_TOKEN } from "@/shared/constants/cookies-const";
import { setHeaders } from '@/shared/services/headers';
import axios from "axios";
export default {
    name: 'Header',
    data(){
        return{
            loggedUserCheck: null,
            inputvalue: [
            {
            value: 100,
            },
            {
            value: 500,
            },
            {
            value: 1000,
            },
            {
            value: 2000,
            },
        ],
        }
    },
    components: {
        Login: defineAsyncComponent(() =>
            import('@/modules/authorization/components/Login.vue')
        ),
        SignUp: defineAsyncComponent(() =>
            import('@/modules/authorization/components/SignUp.vue')
        ),
        ForgetPassword: defineAsyncComponent(() =>
            import('@/modules/authorization/components/ForgetPassword.vue')
        ),
        Account: defineAsyncComponent(() =>
            import('@/modules/account/components/Account.vue')
        ),
    },
    methods: {
        goToWalletDeposit() {
            this.$router.push({name: 'wallet-deposit'});
        },
        goToWalletWithdraw() {
            this.$router.push({name: 'wallet-withdraw'});
        },
     demoLoginServiceCall() {
        let data = {
            "userid": "demouser",
            "type": 2,
            "password": "demopass",
            "cncode": 91,
        };
        this.$store.dispatch('setGlobalLoader', true);
        this.$apiCall('post', 'DEMO_LOGIN_API', data).then(response => {
            this.$store.dispatch('setGlobalLoader', false);
            if (response) {
                if (response.status == 200) {
                    if (response?.data?.status == 0) {
                        this.$errorToast(response.data.debug[0]);
                    } else {
                        this.$successToast(response.data.message);
                        let userData = response.data.data;
                        this.$store.dispatch('setClickBetValue',this.inputvalue);
                        this.$cookies.set(AUTH_TOKEN, userData.token);
                        this.$store.dispatch('setToken', `Bearer ${userData.token}`);
                        window.authorization_token = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`
                        //for add on all APIs
                        axios.defaults.headers.common['Authorization'] = `Bearer ${this.$cookies.get(AUTH_TOKEN)}`;
                        localStorage.setItem("LoggedUser",userData.userid)
                        setHeaders();
                        this.setUserDataToStore(userData);
                        setTimeout(() => {
                            location.reload();
                        }, 100);
                    }
                }
            }
        }).catch(error => {
            this.$store.dispatch('setGlobalLoader', false);
            if (error) {
                this.$errorToast(error[0]);
            }
        });
    },
    setUserDataToStore(userData) {
        let asciiCodes = null;
        for (let i = 0; i < userData.userid.length; i++) {
            asciiCodes += userData.userid.charCodeAt(i)
        }
        let user = {
            balance: userData.balance,
            currency: userData.currency,
            currency_slug: userData.currency_slug,
            last_login_at: userData.last_login_at,
            name: userData.name,
            rid: userData.rid,
            userid: userData.userid,
            exposure: userData.expl,
            available_credits: userData.available_credits,
            id: userData.id,
            exp: userData.exp,
            notificationSubscribed: null,
            notificationUnsubscribed: null,
            activeWallet: userData.actw,
            asciiCodes: asciiCodes,
            cpi: userData.cpi,
        }
        this.$store.dispatch('setUser', user);
        this.$store.dispatch('setChips', userData.chips);
        this.$store.dispatch('setEventManage', userData.lock_settings);
    },
    }
}
</script>